// frontend/src/components/Dashboard/StatsGrid.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StatsGrid = ({ stats, children }) => {
  return <div className="stats-grid">{children}</div>;
};

export const StatCard = ({
  icon,
  title,
  value,
  sub,
  iconColor,
  borderColor,
  className = "",
}) => {
  return (
    <div
      className={`stat-card ${className}`}
      style={{ borderColor: borderColor || "transparent" }}
    >
      <div
        className="stat-icon"
        style={{
          background: iconColor ? `${iconColor}15` : "rgba(0,107,46,0.1)",
        }}
      >
        <FontAwesomeIcon
          icon={icon}
          style={{ color: iconColor || "#006B2E" }}
        />
      </div>
      <div className="stat-info">
        <h3>{title}</h3>
        <div className="stat-value">{value}</div>
        {sub && <div className="stat-sub">{sub}</div>}
      </div>
    </div>
  );
};

export default StatsGrid;